import Vue from 'vue';

Vue.filter('langjson', value => {
    if (value) {
        try {
            return JSON.parse(value).zh;
        } catch (e) {
        }
    }
    return value;
});
